import { SummaryRow } from '../../../Summary/SummaryRow';
import { Q } from '../../../../store/student/types';
import { passportStatusLabel } from '../../../pages/personal-info/qPage7/utils';
import { IRisk } from '../../../../types';
import { useTranslation } from "react-i18next";

interface Props {
  showRisks: boolean;
  passportStatus?: string;
  passportExpiry?: string;
  passportExpected?: string;
  riskList?: IRisk['personalInfoRisk']['passportDetails'];
}

function PassportDetails({ showRisks, passportStatus, passportExpiry, passportExpected, riskList = [] }: Props) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      {passportStatus && (
        <SummaryRow
          key="passportStatus"
          label={t('forms.visa:passportStatus')}
          fullLabel="Do you currently have a passport?"
          value={passportStatusLabel(passportStatus)}
          isRisk={showRisks && riskList.includes(Q.PASSPORT_STATUS)}
        />
      )}
      {passportStatus === 'Yes' && passportExpiry && (
        <SummaryRow
          key="passportExpiry"
          label={t('forms.visa:passportExpiryDate')}
          value={passportExpiry}
          isDate={true}
          isRisk={showRisks && riskList.includes(Q.PASSPORT_EXPIRY)}
        />
      )}
      {passportStatus !== 'Yes' && passportExpected && (
        <SummaryRow
          key="passportExpected"
          label={t('forms.visa:passportExpected')}
          fullLabel="When do you expect to receive your passport?"
          value={passportExpected}
          isDate={true}
          isRisk={showRisks && riskList.includes(Q.PASSPORT_EXPECTED)}
        />
      )}
    </>
  );
}

export default PassportDetails;
